import { dateToTimestamp } from 'shared/helpers/parsers/date';

const parseMarkAsPaidData = paidAt => ({ paidAt: dateToTimestamp(paidAt) });

export { parseMarkAsPaidData };
